export const FIXED_SIDEBAR_WIDTH_OPEN = 250;
export const FIXED_SIDEBAR_WIDTH_CLOSED = 80;

export const FIXED_HEADER_HEIGHT = 80;
